// extracted by mini-css-extract-plugin
module.exports = {"badge":"BadgesCard_badge__tLaZB","cardBox":"BadgesCard_cardBox__MTVoS","cardLinkWrapper":"BadgesCard_cardLinkWrapper__igbqB","notLink":"BadgesCard_notLink__RAsNw"};